import React from 'react';
import Imgix from "react-imgix";
import {AVATAR_PATH, DEFAULT_PRESET_IMAGE_PATH} from "../../common/constants";
import {useAppSelector} from "../../creator-presets/DAL/store";
import {format} from "date-fns";
import ShareIcons from "./share-icons";
import LikesPluginsMacros from "./likes-plugins-macros";
import {getEpochFromDate} from "../../common/services/logic-provider";
import VerifiedIcon from "../../../../ui/svg/common/verified";
import {sendGAEvent} from "../../../../domain/marketing/gtm-provider";


const CreatorDetailsMobile = () => {

    const PresetPageData = useAppSelector((store) => store.PresetPageData);
    const mainPreset = useAppSelector((store) => store.mainPreset);
    const imgCdnDomain = useAppSelector((store) => store.imgCdnDomain);
    const creatorsPath = useAppSelector((store) => store.creatorsPath);

    return (
        <div className="w-full">
            <div className="w-full flex items-center justify-center">
                <div className="w-12 h-12 mr-2">
                    {PresetPageData.profile.imgExt.length > 0 ?
                        <Imgix
                            src= {imgCdnDomain + "/" +
                                  creatorsPath +
                                  PresetPageData.profile.prfUserGUID + "."  +
                                  PresetPageData.profile.imgExt  + "?epoch=" + getEpochFromDate(PresetPageData.profile.itemModifiedWhen)}
                            sizes={"auto"}
                            width={200}
                            height={200}
                            imgixParams={{ mask:"ellipse" }}
                            htmlAttributes={{
                                alt: `${PresetPageData.profile.handle} profile image`,
                                loading: 'lazy',
                            }}

                        />
                        :
                        <Imgix
                            src= {imgCdnDomain + AVATAR_PATH}
                            sizes={"auto"}
                            width={200}
                            height={200}
                            imgixParams={{ fit: "facearea",facepad:"1.9",mask:"ellipse" }}
                            htmlAttributes={{
                                alt: `${PresetPageData.profile.handle} profile image`,
                                loading: 'lazy',
                            }}
                        />
                    }
                </div>
                <div className="flex-1  w-ellipsis">
                    <div className="w-full font-bold w-ellipsis flex items-center">
                        <span>{PresetPageData.profile.publicName}</span>
                        {PresetPageData.profile.isVerified &&
                            <div className="ml-2">
                                <VerifiedIcon width="15px" />
                            </div>
                        }
                    </div>

                    <div className="w-full  w-ellipsis">
                        <a className="text-black"
                           onClick={(evt) => {
                               sendGAEvent('Click', "Profile : " + PresetPageData.profile.handle);
                           }}
                           href={"/studioverse/creator/" + PresetPageData.profile.handle.toLowerCase()}>
                            @{PresetPageData.profile.handle}
                        </a>
                    </div>

                </div>
            </div>
            <div className="w-full mt-5">
                <div className="inline-block" style={{width:"auto"}}>
                    {mainPreset.imgExt.length > 0 ?
                        <Imgix
                            src= {imgCdnDomain + "/images/studioverse/presets/"+ mainPreset.imgGUID + "."
                                +  mainPreset.imgExt
                                + "?epoch=" + getEpochFromDate(mainPreset.imgLastModified)}
                            sizes={"auto"}
                            width={400}
                            height={300}
                            imgixParams={{ fit: "crop" }}
                            htmlAttributes={{
                                alt: `Image for ${ mainPreset.presetName }`,
                                loading: 'lazy',
                            }}
                        />
                        :
                        <Imgix
                            src= {imgCdnDomain + DEFAULT_PRESET_IMAGE_PATH }
                            sizes={"auto"}
                            width={400}
                            height={250}
                            imgixParams={{ fit: "crop" }}
                            htmlAttributes={{
                                alt: `Image for ${ mainPreset.presetName }`,
                                loading: 'lazy',
                            }}
                        />
                    }
                </div>

            </div>
            <div className="flex justify-between py-4">
                <div className="">
                    {format(new Date(mainPreset.createDate), 'MMM d, yyyy')}
                </div>
                <ShareIcons />

            </div>
            <div className="w-full mt-4">{mainPreset.description}</div>
            <div className="w-full flex items-center justify-between mt-4">
                <LikesPluginsMacros />
            </div>
        </div>
    )
};

export default CreatorDetailsMobile;